document.addEventListener("DOMContentLoaded", function () {
  // Check if the current page is the specific product page
  if (window.location.pathname === "/products/the-superfans-club-gifted-subscription") {
    function createSnowflake() {
      const snowflake = document.createElement("div");
      snowflake.classList.add("snowflake");
      snowflake.textContent = "❄"; // Snowflake character

      // Randomize position and animation duration
      snowflake.style.left = Math.random() * 100 + "vw";
      snowflake.style.animationDuration = Math.random() * 3 + 2 + "s";

      document.body.appendChild(snowflake);

      // Remove snowflake after it falls
      setTimeout(() => {
        snowflake.remove();
      }, 5000);
    }

    // Create snowflakes at intervals
    setInterval(createSnowflake, 200);
  }
});
